import { Link } from "react-router-dom";
import { featuredProperties } from "../../../mocks/gallery";
import { useScrollReveal } from "../../../hooks/useScrollReveal";

export default function GalleryPreview() {
  const { ref, isVisible } = useScrollReveal();

  return (
    <section className="py-32 px-8 lg:px-16 bg-white">
      <div className="max-w-screen-xl mx-auto">
        {/* Header */}
        <div
          ref={ref}
          className={`text-center mb-20 transition-all duration-800 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <p className="section-label mb-5">Kuratierte Auswahl</p>
          <h2 className="section-title-lg mb-6">The Private Gallery</h2>
          <span className="gold-divider mb-8" />
          <p className="text-text-secondary font-sans font-light text-base leading-relaxed max-w-xl mx-auto">
            Handverlesene Objekte, für die wir exklusive digitale Markenwelten geschaffen haben.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
          {featuredProperties.map((property, index) => (
            <Link
              key={property.id}
              to={property.externalUrl.startsWith("http") ? property.externalUrl : property.externalUrl}
              className={`group relative overflow-hidden block transition-all duration-800 ${
                isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"
              }`}
              style={{ transitionDelay: `${index * 150}ms` }}
            >
              {/* Image */}
              <div className="aspect-[4/5] overflow-hidden">
                <img
                  src={property.imageUrl}
                  alt={`${property.title} — ${property.subtitle} in ${property.location} | SPDB Studio`}
                  className="w-full h-full object-cover object-top transition-transform duration-800 group-hover:scale-105"
                />
              </div>

              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent opacity-80 group-hover:opacity-100 transition-opacity duration-400" />

              {/* Tag */}
              {property.isDemo && (
                <div className="absolute top-6 left-6">
                  <span className="text-xs font-sans text-white/70 tracking-luxury uppercase border border-white/30 px-3 py-1 bg-black/20">
                    Demo
                  </span>
                </div>
              )}

              {/* Content */}
              <div className="absolute bottom-0 left-0 right-0 p-8">
                <p className="text-xs tracking-luxury font-sans text-gold-light mb-2 uppercase">
                  {property.location}
                </p>
                <h3 className="font-serif text-2xl text-white font-medium mb-4">{property.title}</h3>
                <span className="inline-flex items-center gap-2 text-xs tracking-luxury font-sans text-white/60 uppercase group-hover:text-gold-light transition-colors duration-300">
                  Exposé besuchen
                  <i className="ri-arrow-right-line text-sm" />
                </span>
              </div>
            </Link>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <Link to="/gallery" className="btn-dark">
            Alle Objekte ansehen
          </Link>
        </div>
      </div>
    </section>
  );
}
